import { FilterProps } from '../filter-container';
import { useTranslation } from 'react-i18next';
import { useGetLastBlockInfo } from '../../../hooks';
import Big from 'big.js';
import React from 'react';
import { RangeFilter } from './range-filter';

export const BlockHeightFilter = (props: FilterProps) => {
  const { t } = useTranslation();
  const { data: lastBlock } = useGetLastBlockInfo();
  const lastBlockHeight = lastBlock?.height;

  const handleValidateBlockHeights = (
    state: Record<'from' | 'to', string>
  ): Record<'from' | 'to', string | null> => {
    const numericInputRegExp = new RegExp('^[0-9]+$');
    const errorMap = Object.fromEntries(
      Object.entries(state).map(([key, value]) => {
        if (!value) return [key, null];

        const isNumericInput = numericInputRegExp.test(value?.trim());
        if (!isNumericInput) return [key, t('Value should be numeric')];

        const toValueIsLessThanZero = key === 'to' && Big(value || 0).lte(0);
        if (toValueIsLessThanZero)
          return [key, t('Value should be more than 0')];

        const toValueIsLessThanFromValue =
          key === 'to' && Big(value || 0).lt(state.from || 0);
        if (toValueIsLessThanFromValue)
          return [
            key,
            t('The ‘To’ value must be greater than the ‘From’ value.'),
          ];

        const isValueExceedsLatestEra = Big(value).gt(lastBlockHeight);
        return [
          key,
          isValueExceedsLatestEra
            ? t('Value should not exceed last block height')
            : null,
        ];
      })
    );

    return errorMap;
  };

  return (
    <RangeFilter
      fromFilterId={'from_block_height'}
      toFilterId={'to_block_height'}
      label={t('Block range')}
      handleValidateInputs={handleValidateBlockHeights}
      {...props}
    />
  );
};
